import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { ChevronRight, ChevronLeft } from 'react-feather';
import useWindowSize from 'utils/useWindowSize';
import { Typography, Box } from '@mui/material';

const Slider = ({ linkData, interval = 3000 }) => {
    console.log('fff', linkData);
    const { sizes } = useWindowSize();
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        if (!linkData?.length) return;
        const timer = setInterval(() => {
            setActiveIndex((prev) => (prev + 1) % linkData.length);
        }, interval);
        return () => clearInterval(timer);
    }, [linkData?.length, interval]);

    const NavButton = ({ onClick, direction }) => (
        <button
            onClick={onClick}
            style={{
                all: 'unset',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)',
                [direction === 'next' ? 'right' : 'left']: 0,
                width: 40,
                height: 80,
                background: 'hsl(var(--primary-900))',
                cursor: 'pointer',
                zIndex: 10,
                transition: 'opacity .2s',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.8')}
            onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
        >
            {direction === 'next' ? (
                <ChevronRight color="white" size={28} />
            ) : (
                <ChevronLeft color="white" size={28} />
            )}
        </button>
    );

    const Indicators = ({ current, total }) => (
        <div
            style={{
                position: 'absolute',
                bottom: 24,
                left: '50%',
                transform: `translateX(${-total * 14}px)`,
                display: 'flex',
                flexDirection: 'row',
                gap: 6,
                zIndex: 10,
            }}
        >
            {Array.from({ length: total }).map((_, i) => (
                <div
                    key={i}
                    style={{
                        height: 10,
                        borderRadius: 5,
                        transition: 'width .3s, background .3s',
                        background:
                            i === current ? 'hsl(var(--secondary))' : 'rgba(255,255,255,0.33)',
                        width: i === current ? 39 : 10,
                    }}
                />
            ))}
        </div>
    );

    const height = sizes.sm ? 439 : 639;

    if (!linkData?.length) return <div style={{ height }} />;

    return (
        <div style={{ position: 'relative', height }}>
            <Carousel
                showThumbs={false}
                showStatus={false}
                showIndicators={false}
                infiniteLoop
                selectedItem={activeIndex}
                onChange={setActiveIndex}
                renderArrowNext={(onClick) => <NavButton onClick={onClick} direction="next" />}
                renderArrowPrev={(onClick) => <NavButton onClick={onClick} direction="prev" />}
            >
                {linkData.map((item) => (
                    <div key={item.id}>
                        <div
                            style={{
                                position: 'relative',
                                height,
                                width: '100%',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: 'cover',
                                backgroundImage: item.image?.endsWith('.mp4')
                                    ? 'none'
                                    : `url(${item.image})`,
                            }}
                        >
                            {item.image?.endsWith('.mp4') && (
                                <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                    }}
                                >
                                    <source src={item.image} type="video/mp4" />
                                </video>
                            )}
                            <Box
                                sx={{
                                    position: 'absolute',
                                    bottom: 0,
                                    left: 0,
                                    maxWidth: 700,
                                    textAlign: 'left',
                                    m: sizes.sm ? 3 : 10,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 1,
                                }}
                            >
                                <Typography variant="body16" className="text-white">
                                    {item.subTitle}
                                </Typography>
                                <Typography
                                    variant={sizes.sm ? 'h30' : 'h61'}
                                    className="text-white"
                                >
                                    {item.title}
                                </Typography>
                            </Box>
                        </div>
                    </div>
                ))}
            </Carousel>
            <Indicators current={activeIndex} total={linkData.length} />
        </div>
    );
};

export default Slider;
